import { InventoryItem, NotificationMood, TodoItem, UserContactInfo } from "@/components/Types";
import { ObjectId } from "mongodb";

export const PusherEvent = {
    userCreditsUpdated: 'userCreditsUpdated',
    messageReceived: 'messageReceived',
    agentTyping: 'agentTyping',
    agentTypingStopped: 'agentTypingStopped',
    systemNotification: 'systemNotification',
    progressUpdated: 'progressUpdated',
    achievementUnlocked: 'achievementUnlocked',
    itemReceived: 'itemReceived',
    itemEnriched: 'itemEnriched',
    itemTaken: 'itemTaken',
    xpReceived: 'xpReceived',
    rewardReceived: 'rewardReceived',
    levelUp: 'levelUp',
    todoTaskCompleted: 'todoTaskCompleted',
    todoTaskCreated: 'todoTaskCreated',
    contactAdded: 'contactAdded',
} as const;

export interface UserLangProgressPayload {
    _id: string;
    language: string;
    experience: number;
    experienceTillNextLevel?: number; 
    rankLevel: number; 
}

export interface MessageReceivedPayload {
    chatId: string;
    messageId: string;
    updatedAt: Date;
}

export interface ItemReceivedPayload {
    chatId: string;
    item: InventoryItem;
}

export interface ItemTakenPayload {
    chatId: string;
    item: InventoryItem;
}

export interface ItemEnrichedPayload {
    chatId: string;
    itemId: string;
    imageUrl: string;
    alias: string;
}

export interface TodoTaskCompletedPayload {
    listId?: string;
    language?: string;
    todoItem: {
        _id: ObjectId;
        title?: string;
        emoji?: string;
        xpAward?: number;
        completedAt?: Date;
    };
    progress?: UserLangProgressPayload;
}

export interface ContactAddedPayload {
    language: string;
    contact: Partial<UserContactInfo>;
}   

export interface TodoTaskCreatedPayload {
    listTag: string;
    language: string;
    todoItem: {
        _id: ObjectId;
        title: string;
        emoji: string;
        description: string;
        completedAt: Date;
        chatConfig?: {
            avatarUrl?: string | null;
            characterId?: string | null;
        } | null;
        clickableUrl?: {
            text: string;
            url: string;
            color?: string | null;
            icon?: string | null;
        } | null;
        notification?: {
            from: string;
            characterTag?: string;
            characterId?: string;
            text: string;
            url?: string;
            urlText?: string;
            mood?: NotificationMood;
        } | null;
    };
}

export interface RewardReceivedPayload {
    language: string;
    todoItemTag?: string | null;
    rewardItem: Partial<InventoryItem>;
}

export type PusherEventType = typeof PusherEvent[keyof typeof PusherEvent];

export const pusherGetUserChannelName = (userId: string) => {
    return `user-${userId}`;
}

// Helper function to validate event types
export const isValidPusherEvent = (eventType: string): eventType is PusherEventType => {
    return Object.values(PusherEvent).includes(eventType as PusherEventType);
};